import { useContext } from 'react';

import type { Page } from 'src/shared/telemetry';

import { context as segmentHistoryContext } from '../useSegmentHistory';

type CurrentPage = Page | null;

const useCurrentPage = (): CurrentPage => {
  const { page } = useContext(segmentHistoryContext);

  return page;
};

export { useCurrentPage };
